<template>
    <div></div>
</template>

<script>
export default {
    name: 'personal'
}
</script>

<style>
</style>